import { create } from 'zustand';

/**
 * Measure-mode state — the last clicked range point. Session-only (not
 * persisted): a range readout is a momentary tool, not a plan.
 */
export interface MeasurePoint {
  lat: number;
  lon: number;
}

interface MeasureStore {
  point: MeasurePoint | null;
  set: (p: MeasurePoint) => void;
  clear: () => void;
}

export const useMeasure = create<MeasureStore>((set) => ({
  point: null,
  set: (point) => set({ point }),
  clear: () => set({ point: null }),
}));
